var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsChips001',{attrs:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }